<template>
  <div class="text-dark">
    <b-container fluid>
      <div v-if="detailSubscription && isBjbVa && normalizedStatus">
        <b-row align-h="center">
          <b-col xl="5" lg="6" md="8" sm="9" xs="12">
            <!-- Title -->
            <b-row class="mb-1">
              <b-col class="size24 fw-bold-800">
                {{ normalizedStatus === 'pending' ? 'Detail Transaksi' : 'Detail Berlangganan' }}
              </b-col>
            </b-row>

            <!-- ID -->
            <b-row class="mb-2">
              <b-col>ID Transaksi</b-col>
              <b-col
                class="text-right"
                :class="{ 'cursor-pointer': normalizedStatus === 'success' }"
                @click="normalizedStatus === 'success' && print()"
              >
                <template v-if="normalizedStatus === 'success'">
                  <b-button class="bg-white border-8">
                    {{ detailSubscription.invoice_number }}
                  </b-button>
                </template>
                <template v-else>
                  {{ detailSubscription.invoice_number }}
                </template>
              </b-col>
            </b-row>

            <!-- Status -->
            <b-row class="mb-2">
              <b-col>Status</b-col>
              <b-col class="text-right">
                <span :class="['p-1','rounded-pill','fw-bold-700', statusBadgeClass]">
                  {{ statusLabel }}
                </span>
              </b-col>
            </b-row>

            <!-- Paket -->
            <b-row class="mb-2" v-if="detailSubscription.subscription_renewal">
              <b-col>Paket Berlangganan</b-col>
              <b-col class="text-right">
                {{ detailSubscription.subscription_renewal.renewal_name }}
              </b-col>
            </b-row>

            <!-- Nominal (pakai sell_price jika ada) -->
            <b-row class="mb-2" v-if="amountValue != null">
              <b-col>Total Kredit </b-col>
              <b-col class="text-right">
                {{ amountValue | formatInvoice }}
              </b-col>
            </b-row>

            <!-- Total / Total Tagihan -->
            <b-row class="mb-2">
              <b-col>Total Tagihan </b-col>
              <b-col class="text-right">
                {{ parseFloat(detailSubscription.total) | formatAmount }}
              </b-col>
            </b-row>

            <!-- Metode Pembayaran + VA -->
            <b-row class="mb-2">
              <b-col>Metode Pembayaran</b-col>
              <b-col class="text-right">
                BJB VA - {{ detailSubscription.xendit_provider.va_account_number }}
                <feather-icon
                  icon="CopyIcon"
                  class="text-primary cursor-pointer"
                  size="16"
                  @click="copyToClipboard(detailSubscription.xendit_provider.va_account_number)"
                />
                <div v-if="copied" class="badge badge-light-success mt-50">
                  Berhasil disalin!
                </div>
              </b-col>
            </b-row>

            <!-- Waktu Transaksi -->
            <b-row class="mb-2" v-if="detailSubscription.created_at">
              <b-col>Waktu Transaksi</b-col>
              <b-col class="text-right">
                {{ detailSubscription.created_at }}
              </b-col>
            </b-row>

            <!-- Bayar Sebelum / Berlaku Hingga -->
            <b-row class="mb-5" v-if="expireValue">
              <b-col>{{ expireLabel }}</b-col>
              <b-col class="text-right" :class="{ 'text-danger': normalizedStatus === 'pending' }">
                {{ expireValue }}
              </b-col>
            </b-row>

            <!-- Cara Bayar (pending + bni_va) -->
            <template v-if="showCaraBayar">
              <b-row class="mb-1">
                <b-col class="size24 fw-bold-800">Cara Bayar</b-col>
              </b-row>

              <div class="card p-1" v-b-toggle.collapse-1 variant="primary">
              <div class="d-flex align-items-center">
                <b-img
                  :src="require('/src/assets/images/logo/bjb.png')"
                  alt="bca"
                  style="width: 4rem"
                />
                <span class="ml-1">
                  Bank Pembangunan Daerah Jawa Barat dan Banten - Virtual Account
                </span>
                <span class="ml-auto">
                  <feather-icon icon="ChevronDownIcon" size="16" />
                </span>
              </div>
              <b-collapse id="collapse-1">
                <hr />
                <div class="size16 fw-bold-900 ml-1">Melalui ATM</div>
                <ol>
                  <li>Masukkan kartu ATM BJB anda</li>
                  <li>Masukkan PIN</li>
                  <li>Pilih menu "Transaksi Lainnya"</li>
                  <li>Pilih menu "Virtual Account"</li>
                  <li>Lalu pilih rekening debet yang akan digunakan</li>
                  <li>Masukkan Nomor Virtual Account anda</li>
                  <li>Konfirmasi detail transaksi anda</li>
                  <li>
                    Setelah transaksi anda selesai, invoice ini akan diupdate
                    secara otomatis. Proses ini mungkin memakan waktu hingga 5
                    menit
                  </li>
                </ol>
                <div class="size16 fw-bold-900 ml-1">
                  Melalui Aplikasi BJB Mobile
                </div>
                <ol>
                  <li>Buka aplikasi BJB Mobile</li>
                  <li>Masukkan User ID dan Password</li>
                  <li>Pilih menu "Virtual Account"</li>
                  <li>Lalu pilih rekening debet yang akan digunakan</li>
                  <li>Masukkan Nomor Virtual Account anda</li>
                  <li>Konfirmasi detail transaksi anda</li>
                  <li>
                    Setelah transaksi anda selesai, invoice ini akan diupdate
                    secara otomatis. Proses ini mungkin memakan waktu hingga 5
                    menit
                  </li>
                </ol>
              </b-collapse>
            </div>
            </template>
          </b-col>
        </b-row>
      </div>
    </b-container>

    <!-- Tetap dipakai untuk print; tidak membuat komponen baru -->
    <InvoiceSubscription :detailSubscription="detailSubscription" class="d-none" />
  </div>
</template>

<script>
import { BContainer, BRow, BCol, BImg, BButton, BCollapse, VBToggle } from "bootstrap-vue";
import InvoiceSubscription from "@/components/InvoiceSubscription.vue";

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BImg,
    BButton,
    BCollapse,
    InvoiceSubscription,
  },
  directives: { "b-toggle": VBToggle },
  props: {
    detailSubscription: { type: Object, required: true },
  },
  data() {
    return { copied: false };
  },
  computed: {
    normalizedStatus() {
      return this.detailSubscription?.xendit_provider?.payment_status || null;
    },
    isBjbVa() {
      return this.detailSubscription?.xendit_provider?.payment_method === "bjb_va";
    },
    statusMeta() {
      const map = {
        pending: { label: "Menunggu Pembayaran", badge: "bg-warning" },
        success: { label: "Aktif", badge: "bg-primary" },
        canceled: { label: "Dibatalkan", badge: "bg-danger text-white" },
        expired: { label: "Kedaluwarsa", badge: "secondary-2 text-white" },
      };
      return map[this.normalizedStatus] || { label: "-", badge: "badge-light" };
    },
    statusLabel() {
      return this.statusMeta.label;
    },
    statusBadgeClass() {
      return this.statusMeta.badge;
    },
    amountValue() {
      if (this.normalizedStatus === "pending") {
        // uses custom filter formatInvoice
        return this.detailSubscription?.amount != null
          ? this.$options.filters?.formatInvoice
            ? this.$options.filters.formatInvoice(this.detailSubscription.amount)
            : this.detailSubscription.amount
          : null;
      }
      // success/canceled/expired use total | formatAmount
      if (this.detailSubscription?.total != null) {
        return this.$options.filters?.formatAmount
          ? this.$options.filters.formatAmount(this.detailSubscription.total)
          : this.detailSubscription.total;
      }
      return null;
    },
    expireLabel() {
      return this.normalizedStatus === "pending" ? "Bayar Sebelum" : "Berlaku Hingga";
    },
    expireValue() {
      return this.detailSubscription?.payment_expired_at || null;
    },
    showCaraBayar() {
      return this.normalizedStatus === "pending" && this.isBjbVa;
    },
  },
  methods: {
    async copyToClipboard(text) {
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(text);
        } else {
          const textArea = document.createElement("textarea");
          textArea.value = text;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand("copy");
          document.body.removeChild(textArea);
        }
        this.copied = true;
        setTimeout(() => (this.copied = false), 1500);
      } catch {
        this.copied = false;
      }
    },
    async print() {
      const { hostname, protocol, port } = window.location;
      const noLandscapeOptions = {
        name: "_blank",
        specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
        styles: [`${protocol}//${hostname}${port ? `:${port}` : ""}/bootstrap.css`],
        timeout: 1000,
        autoClose: true,
        windowTitle: window.document.title,
      };
      await this.$htmlToPaper("contentPrintSubscription", noLandscapeOptions);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/variables/_variables.scss";

.secondary-2 {
  background-color: $secondary-2;
}
</style>
